import styled from 'styled-components'
import { DateFormat, DateUtility } from 'utility'
import { UserAvatarWithName } from 'components'
import { VideoStats } from './stats'
import { ReadMoreBox } from './read-more'
import { StyledH6, DotSeparator } from './details'

export const CustomStyledStats = styled(VideoStats)`
  display: flex;
  justify-content: flex-start;
  gap: 20px;
`

const VideoDetails = styled.div`
  margin-top: 10px;
  p {
    color: #808080;
    font-weight: normal;
  }
`
export const ItemWrapperModal = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #808080;
  @media (max-width: 1280px) {
    font-size: 12px;
  }
`
const AvatarWrapper = styled.div`
  padding: 8px 0;
`

export const VideoDetailSection = ({ item }) => {
  return (
    <>
      <h5 className="mb-0">{item.title}</h5>
      <AvatarWrapper>
        <UserAvatarWithName id={item.user?.fid} title={item.user?.name} url={item.user?.image} />
      </AvatarWrapper>
      <ItemWrapperModal>
        <div className="content d-flex gap-2">
          <span>{item.competition_name}</span>
          <DotSeparator>•</DotSeparator>
          <span>Round {item.round_number}</span>
        </div>
        <div className="date">
          <span>
            {DateUtility.formatDate(
              new Date(item.createdAt),
              DateFormat.fullDate,
            )}
          </span>
        </div>
      </ItemWrapperModal>
      <VideoDetails>
        <StyledH6>About this video</StyledH6>
        <ReadMoreBox text={item?.description} isModal />
      </VideoDetails>
      {/* <VideoStats item={item} /> */}
      <CustomStyledStats item={item} />
    </>
  )
}
